// extracted by mini-css-extract-plugin
export default {"Contact":"Contact_Contact__Es1ST","ContactSubText":"Contact_ContactSubText__PqMf6","FormColumn":"Contact_FormColumn__osyWa"};